export const PRODUCT_LIST_ACTION = "PRODUCT_LIST_ACTION";
export const PRODUCT_LIST_SUCCESS = "PRODUCT_LIST_SUCCESS";
export const PRODUCT_LIST_ALL_ACTION = "PRODUCT_LIST_ALL_ACTION";
export const PRODUCT_LIST_ALL_SUCCESS = "PRODUCT_LIST_ALL_SUCCESS";
export const PRODUCT_CREATE_ACTION = "PRODUCT_CREATE_ACTION";
export const PRODUCT_FAIL = "PRODUCT_FAIL";
export const PRODUCT_DELETE_ACTION = "PRODUCT_DELETE_ACTION";
export const PRODUCT_GET_UPDATE_ACTION = "PRODUCT_GET_UPDATE_ACTION";
export const PRODUCT_GET_UPDATE_SUCCESS = "PRODUCT_GET_UPDATE_SUCCESS";
export const PRODUCT_UPDATE_ACTION = "PRODUCT_UPDATE_ACTION";
export const PRODUCT_UPDATE_SUCCESS = " PRODUCT_UPDATE_SUCCESS";

export const PRODUCT_CREATE_TRANSLATE_ACTION = "PRODUCT_CREATE_TRANSLATE_ACTION";
export const PRODUCT_CREATE_TRANSLATE_SUCCESS = "PRODUCT_CREATE_TRANSLATE_SUCCESS";

export const PRODUCT_UPDATE_TRANSLATE_ACTION = "PRODUCT_UPDATE_TRANSLATE_ACTION";
export const PRODUCT_UPDATE_TRANSLATE_SUCCESS = "PRODUCT_UPDATE_TRANSLATE_SUCCESS";

export const PRODUCT_DELETE_TRANSLATE_ACTION = "PRODUCT_DELETE_TRANSLATE_ACTION";
export const PRODUCT_DELETE_TRANSLATE_SUCCESS = "PRODUCT_DELETE_TRANSLATE_SUCCESS";